module.exports = __webpack_public_path__ + "img/no_image.f4e369ee.png";